// AGC: Hook exposing feature availability based on BUILD-TIME context
// AGC: CRITICAL - Uses import.meta.env.VITE_APP_CONTEXT (build flag), NOT runtime detection
// AGC: This ensures desktop builds always show desktop UI, Base App builds always show Base App UI
// AGC: UPDATED v5.0.1: Migrated from Farcaster SDK to OnchainKit MiniKit for Base App compatibility

import { useMemo } from 'react'

// AGC: Get app context from environment variable
const getAppContext = (): 'desktop' | 'baseapp' => {
  if (typeof window === 'undefined') {
    return 'desktop'
  }

  // AGC: Allow build-time overrides for deterministic builds
  const override = import.meta.env.VITE_APP_CONTEXT

  // AGC: Check for Base preview tool (base.dev)
  const currentHost = window.location?.hostname || ''
  const currentHref = window.location?.href || ''

  if (currentHost.includes('base.dev') || currentHref.includes('base.dev/preview')) {
    return 'baseapp'
  }

  // AGC: Check for Farcaster developer preview
  if (currentHost.includes('farcaster.xyz') || currentHref.includes('farcaster.xyz/~/developers')) {
    return 'baseapp'
  }

  if (override === 'baseapp') {
    return 'baseapp'
  }
  if (override === 'desktop') {
    return 'desktop'
  }

  // AGC: Default to desktop
  return 'desktop'
}

export interface FeatureFlags {
  isFarcasterContext: boolean // AGC: Deprecated, use isBaseAppContext instead
  isBaseAppContext: boolean
  isDesktopContext: boolean
  isAdminEnabled: boolean
}

export const useFeatureFlags = (): FeatureFlags => {
  return useMemo(() => {
    // AGC: CRITICAL - Use runtime detection (getAppContext) for proper context awareness
    // AGC: This allows Base App preview tools to work correctly even with desktop builds
    const context = getAppContext()

    // AGC: Allow admin panel on localhost (any port) for development, even in Base App builds
    const isLocalhost = typeof window !== 'undefined' && 
      (window.location.hostname === 'localhost' || 
       window.location.hostname === '127.0.0.1' ||
       window.location.hostname.startsWith('192.168.'))

    return {
      // AGC: Legacy property for backward compatibility (deprecated)
      isFarcasterContext: context === 'baseapp',
      isBaseAppContext: context === 'baseapp',
      isDesktopContext: context === 'desktop',
      // AGC: Admin panel enabled on desktop OR localhost (for development access)
      isAdminEnabled: context === 'desktop' || isLocalhost,
    }
  }, [])
}





